import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { EverestAdminRepository } from '../../repository';

class NavigationBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      me: {}
    };

    this.everestRepository = new EverestAdminRepository();
  }

  componentDidMount() {
    this.everestRepository.findMe({}, (data) => this.setState({ me: data }));
  }

  render() {
    var pathname = this.props.location.pathname;

    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <button
          className="navbar-toggler" type="button"
          data-toggle="collapse" data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
            <li className={`nav-item ${pathname === "/everest-admin" ? "active" : ""}`}>
              <Link className={"nav-link"} to={"/everest-admin"}>Home</Link>
            </li>
            <li className={`nav-item ${pathname === "/everest-admin/mountain" ? "active" : ""}`}>
              <Link className={"nav-link"} to={"/everest-admin/mountain"}>Mountain</Link>
            </li>
            <li className={`nav-item ${pathname === "/everest-admin/mountain-peak" ? "active" : ""}`}>
              <Link className={"nav-link"} to={"/everest-admin/mountain-peak"}>M-Peak</Link>
            </li>
            <li className={`nav-item ${pathname === "/everest-admin/mountain-peak-map" ? "active" : ""}`}>
              <Link className={"nav-link"} to={"/everest-admin/mountain-peak-map"}>M-PeakMap</Link>
            </li>
            <li className={`nav-item ${pathname === "/everest-admin/league" ? "active" : ""}`}>
              <Link className={"nav-link"} to={"/everest-admin/league"}>League</Link>
            </li>
          </ul>
          {!this.state.me.id && (
            <a href={"/everest-admin/login"} className="btn btn-primary btn-sm my-2 my-sm-0">로그인</a>
          )}
          {this.state.me.id && (
            <a href={"/oauth2/everest/logout"} className="btn btn-primary btn-sm my-2 my-sm-0">로그아웃</a>
          )}
        </div>
      </nav >
    );
  }
}

var NavigationBarWithRouter = withRouter(NavigationBar);
export { NavigationBarWithRouter as NavigationBar };
